import React from 'react';
import { UserAvatar } from 'components/UserAvatar';
import { Avatar, IconButton, useDisclosure } from '@cardboard-ui/react';
import { UserIcon } from 'components/icons';
import { t } from '@lingui/macro';
import { graphql } from 'relay-runtime';
import { useFragment } from 'utils/graphClient';
import { TodoAssignee_todo$key } from './__generated__/TodoAssignee_todo.graphql';
import { AssignTodoModal } from './AssignTodoModal';

const fragment = graphql`
  fragment TodoAssignee_todo on Todo {
    id
    ...AssignTodoModal_todo
    assignee {
      id
      name
      ...UserHandle_member
      ...UserAvatar_member
    }
    canAssign {
      value
    }
  }
`;

interface TodoAssigneeProps {
  todo: TodoAssignee_todo$key;
}

export const TodoAssignee: React.FC<TodoAssigneeProps> = ({ todo }) => {
  const { id, assignee, canAssign, ..._todo } = useFragment(fragment, todo);

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <IconButton
        size="xs"
        variant="unstyled"
        borderRadius="full"
        _hover={{
          opacity: 0.8,
        }}
        onClick={onOpen}
        aria-label={assignee ? t`Change assignee` : t`Add assignee`}
        isDisabled={!canAssign.value}
      >
        {assignee ? (
          <UserAvatar size="xs" member={assignee} />
        ) : (
          <Avatar
            size="xs"
            bg="gray.200"
            color="gray.600"
            icon={<UserIcon />}
          />
        )}
      </IconButton>

      <AssignTodoModal isOpen={isOpen} onClose={onClose} todo={_todo} />
    </>
  );
};
